import React from "react";
import { Form } from "react-bootstrap";
import Switch from "react-switch";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const ParticipantSwitch: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { name, value, onChange },
  form: { setFieldValue },
  ...props
}) => (
  <Form.Group>
    <Form.Label>{props.label}</Form.Label>
    <br />
    
    {console.log("Switch 1",value)}
    {console.log("Switch Pross",props)}
    {/* <pre>{JSON.stringify(props, null, 2)}</pre> */}
    <div className="r-switch">
      <Switch
        {...props}
        height={26}
        width={72}
        checked={!value}
        disabled={props.disabled || false}
        onChange={(value: any) => {
          console.log("Switch onChange",value)
          setFieldValue(name, !value);
        }}
        uncheckedIcon={
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            paddingRight: 2
          }}
          >
            <img src="/images/un-check.png" alt="un-check" />
          </div>
        }
        checkedIcon={
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            paddingRight: 2
          }}
          >
            <img src="/images/check.png" alt="check" />
          </div>
        }
      />
    </div>
  </Form.Group>
);

export default ParticipantSwitch;
